/* eslint-disable func-names */
/* eslint-disable prefer-rest-params */
/* eslint-disable max-len */

export const connectionStatuses = [
  { value: 'Select All', checked: true },
  { value: 'Pending', checked: true },
  { value: 'Connected', checked: true },
  { value: 'Disconnected', checked: true },
];

export const permissionFilter = [
  { title: 'lifestyleData', value: 'All', titleText: 'Lifestyle Data' },
  { title: 'medicalData', value: 'All', titleText: 'Medical Data' },
  { title: 'viewOtherClinicians', value: 'All', titleText: 'Shared Data' },
];


export const debounce = (func, delay) => {
  let debounceTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};


export const sortItems = (data, datakey, order) => data.sort((a, b) => {
  if (a.ClientInformationArray[0][datakey][0].Value < b.ClientInformationArray[0][datakey][0].Value) {
    return order === 1 ? -1 : 1;
  }
  if (a.ClientInformationArray[0][datakey][0].Value > b.ClientInformationArray[0][datakey][0].Value) {
    return order === 1 ? 1 : -1;
  }
  return 0;
});

export function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

export const isTextEmpty = (text) => {
  if (text && text != null && text !== '') {
    return false;
  }

  return true;
};

export const overlayTopSide = () => {
  const dashboardTopSide = document.getElementsByClassName('dashboard-top-side')[0];
  if (dashboardTopSide) {
    dashboardTopSide.style.position = 'initial';
  }
};

export const unOverlayTopSide = () => {
  setTimeout(() => {
    const dashboardTopSide = document.getElementsByClassName('dashboard-top-side')[0];
    if (dashboardTopSide) {
      dashboardTopSide.style.position = 'sticky';
    }
  }, 500);
};

export const cleanAndUpdateUnitArrayData = (unitArray, allUnits) => {
  if (!Array.isArray(unitArray)) {
    unitArray = unitArray.replaceAll("'", '"');
    unitArray = unitArray.replaceAll(';', ',');
    unitArray = unitArray.replaceAll('}{', '},{');
    unitArray = JSON.parse(unitArray);
  }

  unitArray = unitArray.filter((unit) => {
    const matchedUnit = allUnits.find(x => x.UnitID === unit.UnitId);
    if (!matchedUnit) return false;
    unit.UnitAbrvName = matchedUnit.UnitAbrvName;
    return true;
  });
  return unitArray;
};

export const cleanData = (data) => {
  if (Array.isArray(data)) return data;
  data = data.replaceAll('\\', '');
  data = data.replaceAll('(', '{');
  data = data.replaceAll(')', '}');
  data = data.replaceAll(';', ',');
  data = data.replaceAll('|', ',');
  data = data.replaceAll("'", '"');

  return JSON.parse(data);
};

export const parseSqlArray = (data) => {
  if (Array.isArray(data)) return data;
  data = data.replaceAll('|', ',');
  data = data.replaceAll('\\', '');
  data = data.replaceAll(';', ',');
  data = data.replaceAll("'", '"');
  return JSON.parse(data);
};


export const emptyRecommendation = (selectedDay, measureId, measure, data) => {
    return {
    isHidden: true,
    PrcsParmtrName: '',
    PrcsParmtrValueOne: data.PrcsParmtrValueOne,
    PrcsParmtrValueTwo: '',
    RcmndtnOccurncId: '99999999999999999',
    RcmndtnSortOrdr: '806',
    RcmndtnOccurncDate: selectedDay,
    IsModified: 'FALSE',
    MeasureId: measureId,
    VisualNameOne: 'Left Line Card',
    VisualTypeOne: measure.VisualTypeOne,
    QtyDescrptr_Qty_UnitIdArray: data.QtyDescrptr_Qty_UnitIdArray,
    ActnPhrase: '',
    ProviderId: '3',
    ProviderName: data.ProviderName,
    VisualNameTwo: 'Caption 2',
    VisualTypeTwo: 'Middle Navy',
    VisualFnctnTwo: 'Clickable'
  }
};
